(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.directive('agendaLabelTranslationRow', ['ItemTableService', AgendaLabelTranslationRowDirectiveFn]);

    function AgendaLabelTranslationRowDirectiveFn(ItemTableService) {
        var directive = {
            link: link,
            restrict: 'A',
            replace: true,
            templateUrl: '/app/settings/agendasettings/templates/agenda-label-translation-row.template.html'

        };
        return directive;

        function link(scope, element, attrs) {

            // if editing -> this is the original backup
            var original = null;

            // deactivate item (remove from table if it is new)
            scope.deactivate = function (index) {
                ItemTableService.deactivate(scope.caption, index);
            };

            // edit item
            scope.edit = function () {
                original = ItemTableService.edit(scope.caption);
            };

            // cancel editing -> show original
            scope.cancel = function (index) {
                if (original === null) {
                    ItemTableService.remove(index);
                }
                else {
                    // replace original with current edited item
                    ItemTableService.replace(original, index);
                    // remove backup
                    original = null;
                } // else
            };

            // save editing values
            scope.save = function () {
                ItemTableService.save(scope.caption);
            };
        }
    }

})();